import { NOTIFICATION_STATUS } from '../utils/constants.js';

const getFormattedError = (error) => {
   const { response: { status, statusText } = {}, message = 'Error Occurred' } =
      error;

   return {
      status: status || '',
      content: message,
      title: statusText || '',
      type: NOTIFICATION_STATUS.ERROR,
   };
};

export default getFormattedError;
